import { Component, Input } from '@angular/core';
import { ControlValueAccessorModel, getProvider } from '../../models/control-value-accessor.model';

import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';

@Component({
    selector: 'agpr-slide-toggle',
    templateUrl: './slide-toggle.component.html',
    styleUrls: ['./slide-toggle.component.scss'],
    providers: [getProvider(SlideToggleComponent)],
    standalone: false
})
export class SlideToggleComponent extends ControlValueAccessorModel<any> {

    @Input() id: string = 'slideToggle';
    @Input() options: DropdownOptionModel[];
    @Input() clickToConfirm: boolean = true;

    value: any;
    focused: boolean;

    constructor() {
        super();
    }

    writeValue(value: any): void {
        this.value = value;
    }

    onRadioChanged(value: any): void {
        this.onModelChange(this.value);
    }

    focusToggle(focus: boolean): void {
        this.focused = focus;
    }
}
